import { render, staticRenderFns } from "./BasicInfoForm.vue?vue&type=template&id=b30bd770&"
import script from "./BasicInfoForm.vue?vue&type=script&lang=js&"
export * from "./BasicInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports